import type { SeatCandidate } from './seat-identity';
import type { LocalReview, LocalState } from './storage';

export function sameSeat(a: SeatCandidate, b: SeatCandidate): boolean {
  return a.venueId === b.venueId && a.spaceId === b.spaceId
    && a.sectionCode === b.sectionCode && a.rowLabel === b.rowLabel
    && a.seatNumber === b.seatNumber;
}

export function sameSeatVisit(a: SeatCandidate, b: SeatCandidate): boolean {
  return sameSeat(a, b) && a.layoutVersionId === b.layoutVersionId && a.instanceId === b.instanceId;
}

/** Never guess an orphan's venue or borrow a different candidate's coordinates. */
export function reviewSeat(review: LocalReview, state: Pick<LocalState, 'candidates' | 'seatDecisions'>): SeatCandidate | undefined {
  return review.candidateSnapshot
    ?? state.candidates.find((seat) => seat.candidateId === review.candidateId)
    ?? state.seatDecisions.flatMap((decision) => decision.candidates).find((seat) => seat.candidateId === review.candidateId);
}

export function preserveReviewSeats(state: LocalState): LocalState {
  return { ...state, reviews: state.reviews.map((review) => {
    const seat = reviewSeat(review, state);
    return seat ? { ...review, candidateSnapshot: { ...seat } } : review;
  }) };
}
